<!--suppress CheckEmptyScriptTag -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 48 48"
       height="48"
       width="48">
    <path d="M24 40 8 24 24 8l2.1 2.1-12.4 12.4H40v3H13.7l12.4 12.4Z"
          class="fill"/>
  </svg>
</template>

<script>
/**
 * SVG back icon.
 */
export default {
  name: 'SvgBack',
  props: ['fill', 'stroke'],
}
</script>

<style scoped lang="scss">

</style>
